module.exports = "<div class=\"px-2 text-style\">\n  <p>\n    Permission denied. Please contact K.Chutima (\n    <a href=\"mailto:chutimava@set.or.th\">chutimava@set.or.th</a>) or K.Teerapon (\n    <a href=\"mailto:teerapon@set.or.th\">teerapon@set.or.th</a>)\n  </p>\n</div>"


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/common-component/permission-denied/permission-denied.component.html
// module id = ../../../../../src/app/common-component/permission-denied/permission-denied.component.html
// module chunks = main